import React from "react";
import { DateTime } from "luxon";
import { CustomerTypes, EnquiryStatus } from "constants/enums";
import { ClearLabel } from "components/controls";
import { FieldNames } from "./QuotesFilters";

const FieldMappings = {
  status: "Status",
  customerType: "Customer Type",
  department: "Department",
  createdDateFromUtc: "Created Date From",
  createdDateToUtc: "Created Date To",
};

const FormatDisplay = (item) => {
  let value = item.value;
  switch (item.label) {
    case FieldNames.Status:
      value = item.value.map((x) => EnquiryStatus[x]).join(", ");
      break;
    case FieldNames.CustomerTypes:
      value = item.value.map((x) => CustomerTypes[x]).join(", ");
      break;
    case FieldNames.CreatedDateFrom:
    case FieldNames.CreatedDateTo:
      value = DateTime.fromISO(item.value).toFormat("dd MMM yyyy");
  }

  return `${FieldMappings[item.label] || item.label}: ${value}`;
};

const QuotesFilterDisplay = ({ filters, resetFilters }) => {
  const items = filters
    ? Object.keys(filters)
        .filter(
          (f) =>
            f !== FieldNames.Search &&
            f !== FieldNames.Department &&
            filters[f] != undefined &&
            filters[f] != null &&
            filters[f] != ""
        )
        .map((k) => {
          return {
            label: k,
            value: filters[k],
          };
        })
    : [];

  if (!items.length) return null;

  return (
    <div className="filter-display">
      {items.map((item) => (
        <div
          className="filter-display-item"
          key={item.label}
          title={FormatDisplay(item)}
        >
          {FormatDisplay(item)}
        </div>
      ))}
      <ClearLabel onClick={resetFilters} />
    </div>
  );
};

export default QuotesFilterDisplay;
